const {h, render, Component} = require('preact')
const {route} = require('preact-router')

class NavItem extends Component {
  constructor(props) {
    super(props);
    this.onSelectArticle = this.onSelectArticle.bind(this);
  }

  onSelectArticle(e){
    e.preventDefault()
    window.scrollTo(0,0);
    this.props.handleSelectedArticle(this.props.article)
    if(window.location.hash.split('?')[1])
      route(`/faq#faqs:content-${this.props.article.contentId}?crumbs=${btoa(JSON.stringify(this.props.crumbs))}`)
    else
    route(`/faq#faqs:content-${this.props.article.contentId}`)

  }

  render() {
    return (
      <li id={this.props.article.contentId} onClick={this.onSelectArticle} class={this.props.article.contentId==this.props.selectedIndex?'active':''} data-bhw={"web2018_faq_article_"+this.props.article.contentId}>
        <a href="">{this.props.article.title}</a>
      </li>
    )
  }
}

module.exports = NavItem
